




















































































import { Component, Prop, Vue } from "vue-property-decorator";
@Component
export default class Disclaimer extends Vue {

  @Prop({required: true})
  disclaimer: any

  @Prop({required: true})
  declineButton: boolean
  
  accept() {
    this.$emit('acceptTerms',true)
    this.disclaimer.show = false
  }

  decline() {
    this.$emit('acceptTerms',false)
    this.disclaimer.show = false
  }


}
